import React, { Fragment } from 'react'
import estilos from '../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsRecepcionMateriaPrima.module.css'
import PesadoDeAgaveFormComponent from './ProcesosYEquipo/PesadoDeAgaveFormComponent';
import CoccionFormComponent from './ProcesosYEquipo/CoccionFormComponent';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import estilosgenerales from '../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import { withRouter } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import MoliendaFormComponent from './ProcesosYEquipo/MoliendaFormComponent';
import FermentacionFormComponent from './ProcesosYEquipo/FermentacionFormComponent';
import CuestionarioEnvasadoFormComponent from './ProcesosYEquipo/CuestionarioEnvasadoFormComponent';
import ProcesosYEquipoComponent from './ProcesosYEquipo/ProcesosYEquipoComponent';
import DestilacionFormComponent from './ProcesosYEquipo/DestilacionFormComponent';

function TabsRecepcionMateriaPrimaComponent(props) {

    const tipoInstalacion = props.tipo;
    const informe = props.informe;

    //PRODUCCION
    const [tabUno, setTabUno] = React.useState(tipoInstalacion === 1 ? true : false)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)
    const [tabCinco, setTabCinco] = React.useState(false)

    //ENVASADO
    const [tabSeis, setTabSeis] = React.useState(tipoInstalacion === 2 ? true : false)
    const [tabSiete, setTabSiete] = React.useState(false)
    const [tabOcho, setTabOcho] = React.useState(false)

    //ALMACEN
    const [tabNueve, setTabNueve] = React.useState(tipoInstalacion === 3 ? true : false)
    const [tabDiez, setTabDiez] = React.useState(false)
    const [tabOnce, setTabOnce] = React.useState(false)

    //VARIABLES QUE VAMOS A UTILIZAR:

    const dispatch = useDispatch()


    //PRODUCCION
    const setearValoresUno = () => {
        irASeccion()
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false);
    }
    const setearValoresDos = () => {
        irASeccion()
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false); setTabCinco(false);
    }
    const setearValoresTres = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false); setTabCinco(false);
    }
    const setearValoresCuatro = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(true); setTabCinco(false);
    }
    const setearValoresCinco = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(true);
    }

    //ENVASADO
    const setearValoresSeis = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(true); setTabSiete(false); setTabOcho(false);
    }
    const setearValoresSiete = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(false); setTabSiete(true); setTabOcho(false);
    }
    const setearValoresOcho = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabSeis(false); setTabSiete(false); setTabOcho(true);
    }

    //ALMACEN
    const setearValoresNueve = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabNueve(true); setTabDiez(false); setTabOnce(false);
    }
    const setearValoresDiez = () => {
        irASeccion()
        setTabNueve(false); setTabDiez(true); setTabOnce(false);
    }
    const setearValoresOnce = () => {
        irASeccion()
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(false); setTabCinco(false); setTabNueve(false); setTabDiez(false); setTabOnce(true);
    }


    const irASeccion = () => {
        const element = document.getElementById('inicioTabs');

        if (element) {
            // 👇 Will scroll smoothly to the top of the next section
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <Fragment>
            {
                tipoInstalacion === 1 ?
                    <div className={`row mt-3 mb-5 text-center ${estilos.tabsCuartoNivel} `}>
                        <div className={`col-3 text-center`}>
                            <button onClick={() => setearValoresUno()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabUno ? '#c88b3e' : 'transparent', color: tabUno ? 'white' : 'black' }}>Pesado de Maguey</button>
                        </div>
                        <div className={`col-2 text-center`}>
                            <button onClick={() => setearValoresDos()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabDos ? '#c88b3e' : 'transparent', color: tabDos ? 'white' : 'black' }}>Cocción</button>
                        </div>
                        <div className={`col-2 text-center`}>
                            <button onClick={() => setearValoresTres()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabTres ? '#c88b3e' : 'transparent', color: tabTres ? 'white' : 'black' }}>Molienda</button>
                        </div>
                        <div className={`col-2 text-center`}>
                            <button onClick={() => setearValoresCuatro()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabCuatro ? '#c88b3e' : 'transparent', color: tabCuatro ? 'white' : 'black' }}>Fermentación</button>
                        </div>
                        <div className={`col-3 text-center`}>
                            <button onClick={() => setearValoresCinco()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabCinco ? '#c88b3e' : 'transparent', color: tabCinco ? 'white' : 'black' }}>Destilación</button>
                        </div>
                    </div>
                    :
                    tipoInstalacion === 2 ?
                        <div className={`row mt-3 mb-5 text-center ${estilos.tabsCuartoNivel} `}>
                            {
                                //<div className={`col-3 text-center`}>
                                //    <button onClick={() => setearValoresSeis()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabSeis ? '#c88b3e' : 'transparent', color: tabSeis ? 'white' : 'black' }}>Almacén de Producto a Granel</button>
                                //</div>
                            }
                            <div className={`col-4 text-center`}>
                                <button onClick={() => setearValoresSeis()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabSeis ? '#c88b3e' : 'transparent', color: tabSeis ? 'white' : 'black' }}>Evaluación de la Conformidad</button>
                            </div>
                            <div className={`col-4 text-center`}>
                                <button onClick={() => setearValoresSiete()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabSiete ? '#c88b3e' : 'transparent', color: tabSiete ? 'white' : 'black' }}>Area de Envasado</button>
                            </div>
                            <div className={`col-4 text-center`}>
                                <button onClick={() => setearValoresOcho()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabOcho ? '#c88b3e' : 'transparent', color: tabOcho ? 'white' : 'black' }}>Línea de Envasado Para Otros Productos Alcohólicos</button>
                            </div>

                        </div>
                        :
                        tipoInstalacion === 3 ?
                            <div className={`row mt-3 mb-5 text-center ${estilos.tabsCuartoNivel} `}>
                                {
                                    //<div className={`col-3 text-center`}>
                                    //    <button onClick={() => setearValoresSeis()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabSeis ? '#c88b3e' : 'transparent', color: tabSeis ? 'white' : 'black' }}>Almacén de Producto a Granel</button>
                                    //</div>
                                }
                                <div className={`col-4 text-center`}>
                                    <button onClick={() => setearValoresNueve()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabNueve ? '#c88b3e' : 'transparent', color: tabNueve ? 'white' : 'black' }}>Almacén de Producto a Granel</button>
                                </div>
                                <div className={`col-4 text-center`}>
                                    <button onClick={() => setearValoresDiez()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabDiez ? '#c88b3e' : 'transparent', color: tabDiez ? 'white' : 'black' }}>Almacén de Producto Terminado</button>
                                </div>
                                <div className={`col-4 text-center`}>
                                    <button onClick={() => setearValoresOnce()} type="button" className={`btn ${estilos.botonCircular}`} style={{ background: tabOnce ? '#c88b3e' : 'transparent', color: tabOnce ? 'white' : 'black' }}>Almacén de Maduración</button>
                                </div>

                            </div>
                            :
                            <div></div>
            }
            <hr />
            <div className='row'>
                <div className={`col-12 text-center`}>
                    {
                        tabUno ? (
                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                <PesadoDeAgaveFormComponent informe={props.informe} />
                                <div className="col ">

                                </div>
                                <div className="col ">

                                </div>
                                <div className="col ">

                                </div>
                                <div className="col ">
                                    <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresDos()}>Ir a Cocción<ArrowForwardIcon /></button>
                                </div>
                                <div className="col ">
                                </div>
                            </div>
                        ) :
                            tabDos ? (
                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                    <CoccionFormComponent informe={props.informe} />

                                    <div className="col ">

                                    </div>

                                    <div className="col ">
                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresUno()}><ArrowBackIcon />Ir a Pesado de Maguey</button>
                                    </div>
                                    <div className="col ">
                                        <label className={`btn`}>Cocción </label>
                                    </div>
                                    <div className="col ">
                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresTres()}>Ir a Molienda<ArrowForwardIcon /></button>
                                    </div>

                                    <div className="col ">
                                    </div>
                                </div>
                            ) :
                                tabTres ? (
                                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                        <MoliendaFormComponent informe={props.informe} />
                                        <div className="col ">

                                        </div>
                                        <div className="col ">
                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresDos()}><ArrowBackIcon />Ir a Cocción</button>
                                        </div>
                                        <div className="col ">
                                            <label className={`btn`}>Molienda </label>
                                        </div>
                                        <div className="col ">
                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresCuatro()}>Ir a Fermentación<ArrowForwardIcon /></button>

                                        </div>

                                        <div className="col ">

                                        </div>

                                    </div>
                                ) :
                                    tabCuatro ? (

                                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                            <FermentacionFormComponent informe={props.informe} />
                                            <div className="col ">

                                            </div>
                                            <div className="col ">
                                                <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresTres()}><ArrowBackIcon />Ir a Molienda</button>
                                            </div>
                                            <div className="col ">
                                                <label className={`btn`}>Fermentación </label>
                                            </div>
                                            <div className="col ">
                                                <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresCinco()}>Ir a Destilación<ArrowForwardIcon /></button>

                                            </div>
                                            <div className="col ">

                                            </div>
                                        </div>
                                    ) :
                                        tabCinco ? (

                                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                <DestilacionFormComponent informe={props.informe} solicitud={props.solicitud} />
                                                <div className="col ">

                                                </div>
                                                <div className="col ">
                                                    <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresCuatro()}><ArrowBackIcon />Ir a Fermentación</button>
                                                </div>
                                                <div className="col ">
                                                    <label className={`btn`}>Fermentación </label>

                                                </div>
                                                <div className="col ">

                                                </div>
                                                <div className="col ">

                                                </div>
                                            </div>
                                        ) :
                                            tabSeis ? (

                                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                    {/* <CuestionarioEnvasadoFormComponent informe={props.informe}></CuestionarioEnvasadoFormComponent> */}
                                                    <div className="col ">

                                                    </div>
                                                    <div className="col ">
                                                    </div>
                                                    <div className="col ">
                                                        <label className={`btn`}>Evaluación de la Conformidad</label>
                                                    </div>
                                                    <div className="col ">
                                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresSiete()}>Ir a Area de Envasado<ArrowForwardIcon /></button>

                                                    </div>
                                                    <div className="col ">

                                                    </div>
                                                </div>
                                            ) :
                                                tabSiete ? (

                                                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                        {/* <ProcesosYEquipoComponent informe={props.informe} tipo={tipoInstalacion} idseccion={26} /> */}
                                                        <div className="col ">

                                                        </div>
                                                        <div className="col ">
                                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresSeis()}><ArrowBackIcon />Ir a Evaluación de la Conformidad</button>
                                                        </div>
                                                        <div className="col ">
                                                            <label className={`btn`}>Area de Envasado </label>
                                                        </div>
                                                        <div className="col ">
                                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresOcho()}>Ir a Otros Productos Alcohólicos<ArrowForwardIcon /></button>

                                                        </div>

                                                        <div className="col ">

                                                        </div>
                                                    </div>
                                                ) :
                                                    tabOcho ? (
                                                        <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                            {/* <ProcesosYEquipoComponent informe={props.informe} tipo={tipoInstalacion} idseccion={30} /> */}
                                                            <div className="col ">

                                                            </div>
                                                            <div className="col ">
                                                                <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresSiete()}><ArrowBackIcon />Ir a Area de Envasado</button>
                                                            </div>
                                                            <div className="col ">
                                                                <label className={`btn`}>Otros Productos Alcohólicos </label>

                                                            </div>
                                                            <div className="col ">

                                                            </div>
                                                            <div className="col ">

                                                            </div>
                                                        </div>
                                                    ) :
                                                        tabNueve ? (
                                                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                                {/* <ProcesosYEquipoComponent informe={props.informe} tipo={tipoInstalacion} idseccion={5} /> */}
                                                                <div className="col ">

                                                                </div>
                                                                <div className="col ">
                                                                </div>
                                                                <div className="col ">
                                                                    <label className={`btn`}>Otros Productos Alcohólicos </label>

                                                                </div>
                                                                <div className="col ">
                                                                    <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresDiez()}>Ir a Area de Producto Terminado<ArrowForwardIcon /></button>
                                                                </div>
                                                                <div className="col ">

                                                                </div>
                                                            </div>
                                                        ) :
                                                            tabDiez ? (
                                                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                                    {/* <ProcesosYEquipoComponent informe={props.informe} tipo={tipoInstalacion} idseccion={11} /> */}
                                                                    <div className="col ">

                                                                    </div>
                                                                    <div className="col ">
                                                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresNueve()}><ArrowBackIcon />Ir a Area de Producto a Granel</button>
                                                                    </div>
                                                                    <div className="col ">
                                                                        <label className={`btn`}>Otros Productos Alcohólicos </label>

                                                                    </div>
                                                                    <div className="col ">
                                                                        <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresOnce()}>Ir a Area de Maduración<ArrowForwardIcon /></button>
                                                                    </div>
                                                                    <div className="col ">

                                                                    </div>
                                                                </div>
                                                            ) :
                                                                tabOnce ? (
                                                                    <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                                                        {/* <ProcesosYEquipoComponent informe={props.informe} tipo={tipoInstalacion} idseccion={12} /> */}
                                                                        <div className="col ">

                                                                        </div>
                                                                        <div className="col ">
                                                                            <button type="button" className={`btn ${estilosgenerales.botonSubTab}`} onClick={() => setearValoresDiez()}><ArrowBackIcon />Ir a Area de Producto Terminado</button>
                                                                        </div>
                                                                        <div className="col ">
                                                                            <label className={`btn`}>Otros Productos Alcohólicos </label>

                                                                        </div>
                                                                        <div className="col ">

                                                                        </div>
                                                                        <div className="col ">

                                                                        </div>
                                                                    </div>
                                                                ) :
                                                                    <div></div>
                    }
                </div>
            </div>

        </Fragment>
    );
};


export default withRouter(TabsRecepcionMateriaPrimaComponent)